import React from "react";
import clsx from "clsx";

import { Button } from "components";

import { useTheme } from "context";

import { useAppSelector } from "store/store";

import { selectCombinedData } from "./selectors";

const ActionModal: React.FC = () => {
  const { title, description, btnArr, isLoading } = useAppSelector(selectCombinedData);
  const { theme } = useTheme();

  return (
    <div className="flex flex-col justify-center w-full py-4">
      <h3 className={clsx("text-2xl font-semibold", theme === "light" ? "text-zinc-900" : "text-white")}>{title}</h3>
      <div
        className={clsx("mt-4 text-sm [&_p]:mb-3 [&_strong]:font-semibold", theme === "light" ? "text-zinc-600" : "text-zinc-400")}
        dangerouslySetInnerHTML={{ __html: description }}
      />

      {btnArr && (
        <div className="flex w-full gap-2 mt-8">
          {btnArr.map(({ buttonText, callback, variant = "primary" }, index) => (
            <Button
              pending={isLoading}
              key={`${buttonText}-${index}`}
              variant={variant}
              disabled={isLoading}
              onClick={callback}
            >
              {buttonText}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActionModal;
